import CloseIcon from "@mui/icons-material/CloseOutlined"
import { Box, IconButton, Stack, Typography } from "@mui/material"
import { useTheme } from "@mui/material/styles"

export const RightPage = (props: any) => {
  const theme = useTheme()
  return (
    <Stack
      sx={{
        right: 72,
        top: 133,
        minWidth: "300px",
        maxWidth: "536px",
        borderRadius: "8px",
        backgroundColor: theme.transBkColor.light,
        maxHeight: `calc(100% - 114px)`,
        position: "absolute",
        boxShadow: 6,
        overflow: "hidden",
        ...props.sx,
      }}
      className={props.className}
      direction="column"
    >
      <Stack
        sx={{
          p: "0 12px",
          height: "48px",
          width: "100%",
        }}
        alignItems="center"
        justifyContent="space-between"
        direction={"row"}
      >
        <Typography variant="h6" sx={{ fontWeight: 600 }}>
          {" "}
          {props.title}
        </Typography>
        <IconButton
          sx={{
            width: 30,
            height: 30,
          }}
          onClick={props.onClose}
        >
          <CloseIcon />
        </IconButton>
      </Stack>
      <Box
        sx={{
          p: "24px",
          backgroundColor: "background.paper",
          overflow: "auto",
        }}
        className={props.bodyClassName}
      >
        {props.content}
      </Box>

      {props.actions && <Box sx={{ width: "100%" }}>{props.actions}</Box>}
    </Stack>
  )
}
